/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Grid, Button, Typography, Paper } from '@material-ui/core';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import Hreflang from '../../components/Hreflang';
import { FormattedMessage } from 'react-intl';

import SeoTitle from '../../components/SeoTitle';
import firstImg from './first.png';
import secondImg from './secondImg.png';
import css from './index.module.scss';
import PizzaHutFooter from '../../components/PizzaHutFooter';
const { selectDesktop } = Slices.appSlice;
const AboutPage = () => {
  const config = useSelector((state) => state.config);
  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const profile = useSelector((state) => state.profile);
  const countryName = profile?.country;
  const isDesktop = useSelector(selectDesktop);
  const isExist = contrySpecificValidation?.findIndex(({ country }) => country === countryName);
  // eslint:fix 'tel' + ' ' replaced with 'tel '
  const path = 'tel: ' + contrySpecificValidation?.[isExist].customerCare;
  return (
    <Grid>
      <SeoTitle id="aboutus" />
      <Hreflang page="aboutus" />
      <Header
        title={<FormattedMessage id="aboutus_heading" defaultMessage="About Us" />}
        actionButtons={[<LanguageButton />]}
        // tellNumber={contrySpecificValidation?.[isExist].customerCare}
        // actionButtons={[<LanguageButton />]}
      />

      <Grid className={css.root}>
        {isDesktop && (
          <div className={css.title}>
            <h1>
              <FormattedMessage id="aboutus_heading" defaultMessage="About Us" />
            </h1>
          </div>
        )}

        <div className={css.history}>
          <div className={css.historyBox}>
            <h2>
              <FormattedMessage id="aboutus_history" defaultMessage="Our History" />
            </h2>
          </div>
        </div>
        <div className={css.contentBox}>
          <div className={css.desc}>
            <div className={css.descContent}>
              <p>
                <FormattedMessage id="aboutus_p1" defaultMessage="Our History" />
              </p>
              <p>
                <FormattedMessage id="aboutus_p2" defaultMessage="Our History" />
              </p>
            </div>
            <div className={css.descImg}>
              <img src={firstImg} alt="history" />
            </div>
          </div>
          <div className={css.desc}>
            <div className={css.descContent}>
              <p>
                <FormattedMessage id="aboutus_p3" defaultMessage="Our History" />
              </p>
            </div>
            <div className={css.descImg}>
              <img src={secondImg} alt="history" />
            </div>
          </div>
        </div>
      </Grid>
      <PizzaHutFooter />
    </Grid>
  );
};

export default AboutPage;
